import { TFunction } from "i18next";
import { PaymentShape } from "../models/PaymentShape";
import { ContractType } from "../../contracts/models/ContractType";

/** Human label for a payment's shape — "Standalone" reads as the product term "Drop-in". */
export const paymentShapeLabel = (shape: PaymentShape, t: TFunction): string =>
  t(`billing.shape.${shape}`, { defaultValue: shape });

/** Human label for a contract's type. */
export const contractTypeLabel = (type: ContractType, t: TFunction): string =>
  t(`billing.contractType.${type}`, { defaultValue: type });
